import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PATHS_AUTH_PAGES } from '@pacifico/utils/path-page';
import { IRequestUpdatePassword, IResponseUpdatePassword } from '@pacifico/interfaces/configurations-api';
import { IReqlogout, IResponseLogout, IResponseAuth } from '@pacifico/interfaces/auth-api.interface';
import { ConfigurationsApiService } from '@pacifico/services/api/configurations/configurations-api.service';
import { AuthService } from '@pacifico/services/api/auth/auth.service';
import { IResponse } from '@pacifico/services/api/endpoint-api';
import { TokenService } from '@pacifico/services/api/token.service';
import { SessionStorageService } from '@pacifico/services/local/storage/storage.service';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-first-login-form',
	templateUrl: './first-login-form.component.html',
	styleUrls: ['./first-login-form.component.scss']
})
export class FirstLoginFormComponent implements OnInit {
	requestUpdatePassword!: IRequestUpdatePassword;
	requestLogout!: IReqlogout;
	responseAuth!: IResponseAuth;
	messageErrorPassword = '';
	messagePasswordInput = '';
	token = '';
	showSuccess = false;
	showHeader = false;
	password = '';
	repeatPassword = '';
	@ViewChild('myform') myform!: NgForm;

	constructor(
		private _router: Router,
		private _configurationsApiService: ConfigurationsApiService,
		private _authService: AuthService,
		private _tokenService: TokenService,
		private _sessionStorageService: SessionStorageService
	) {}

	ngOnInit(): void {
		this.responseAuth = this._sessionStorageService.getItem<IResponseAuth>('token')!;
		this.messageErrorPassword = 'Las contraseñas no coinciden';
		this.messagePasswordInput = 'Debe ingresar una contraseña válida';
		this.showHeader = this._tokenService.currentUserValue?.showHeader ?? false;
	}

	get regex(): boolean {
		return /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[&#.,;])[0-9a-zA-Z&#.,;]{8,}$/gm.test(this.myform?.controls.password?.value);
	}

	clickSave(): void {
		if (this.validatePassword() && this.regex) {
			this._updatePassword(this.password, this.responseAuth.user.pCIP, this.responseAuth.user.id.toString());
		}
	}

	goToLogin(): void {
		void this._router.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
	}

	private _updatePassword(password: string, personId: string, userCode: string): void {
		this.requestUpdatePassword = {
			pContrasenaActual: this._tokenService.currentPasswordvalue,
			pContrasenaNueva: password,
			pIdPersona: userCode,
			pOperationCode: '',
			pToken: '',
			pTokenType: '',
			pUserCode: personId
		};

		this._configurationsApiService
			.updatePassword(this.requestUpdatePassword)
			.subscribe((res: IResponse<IResponseUpdatePassword>) => {
				if (res.status.code === '0000') {
					this.showSuccess = true;
					this._logout(this.responseAuth.sessionId);
				}
			});
	}

	private _logout(sessionId: string) {
		this.requestLogout = {
			environment: 'M',
			sessionId: sessionId
		};
		this._authService.logout(this.requestLogout).subscribe((res: IResponseLogout) => {
			if (res.code === '0000') {
				this._tokenService.deleteToken();
				this._tokenService.setPasswordValue('');
				this._sessionStorageService.clear();
				// void this._router.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
			}
		});
	}

	validatePassword(): boolean {
		return this.password.toUpperCase() === this.repeatPassword.toUpperCase() && this.password !== '';
	}

	validateInputPasswordRepeat(): boolean {
		return this.myform?.controls.repeatPassword?.touched && !this.validatePassword();
	}

	validateInputPassword(): boolean {
		return this.myform?.controls.password?.touched && !this.regex;
	}
}
